export default {
  image: 'A4_7.png',
  pdf: '220922_WA-MIWO_006_A4_7_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-006',
    technicalValues: {
      soundReductionIndex: {
        output: '47,6',
        value: 47.6
      },
      heatTransferCoefficient: {
        output: '0,24',
        value: 0.24
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 6',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '≥ 60/100',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-100'
        },
        {
          output: '100 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: 'keine',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: null
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '192',
        value: 192
      }
    }
  }
}
